/**
 * Config: Classes
 * -----------------------------------------------------------------------------
 * Global configuration for Vue states and CSS classes.
 * - Add in alphabetical order.
 *
 */
export default {
  active: 'is-active',
  blurred: 'is-blurred',
  collapsed: 'is-collapsed',
  disabled: 'is-disabled',
  error: 'is-error',
  empty: 'is-empty',
  fixed: 'is-fixed',
  hidden: 'is-hidden',
  loading: 'is-loading',
  minimised: 'is-minimised',
  moved: 'is-moved',
  open: 'is-open',
  selected: 'is-selected',
  tabbable: 'is-tabbable',
  updating: 'is-updating',
  visible: 'is-visible',
}
